import { Component } from '@angular/core';

@Component({
  selector: 'app-bolt',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.22672 17.3324C9.16587 17.3435 9.10352 17.3435 9.04266 17.3324C8.90985 17.2923 8.79377 17.2099 8.71209 17.0978C8.63041 16.9856 8.5876 16.8499 8.59018 16.7112V16.6268L9.28041 11.7568H5.95196C5.83971 11.7569 5.72959 11.7262 5.63358 11.6681C5.53757 11.6099 5.45935 11.5266 5.40744 11.4271C5.34879 11.3271 5.31787 11.2132 5.31787 11.0973C5.31787 10.9813 5.34879 10.8675 5.40744 10.7675L6.94129 8.09093L10.0857 3.09058C10.1556 2.9726 10.2634 2.88181 10.3916 2.83305C10.5197 2.78429 10.6606 2.78045 10.7913 2.82216C10.9241 2.86225 11.0401 2.94463 11.1218 3.05677C11.2035 3.16891 11.2463 3.30466 11.2437 3.44337V3.52773L10.5535 8.3977H13.8896C14.0019 8.3976 14.112 8.4283 14.208 8.48645C14.304 8.54459 14.3822 8.62796 14.4341 8.72748C14.4928 8.82749 14.5237 8.94132 14.5237 9.05726C14.5237 9.17319 14.4928 9.28703 14.4341 9.38704L12.9003 12.0636L9.7559 17.064C9.69812 17.1503 9.6191 17.2204 9.52642 17.2674C9.43375 17.3144 9.33054 17.3368 9.22672 17.3324V17.3324ZM6.80324 10.5758H9.87094C9.95554 10.5768 10.0391 10.5944 10.1169 10.6277C10.1947 10.661 10.2651 10.7093 10.3242 10.7699C10.3833 10.8304 10.43 10.902 10.4614 10.9805C10.4928 11.0591 10.5085 11.1431 10.5075 11.2277V11.312L10.055 14.4871L11.9723 11.4194L13.0767 9.51741H10.009C9.92439 9.51641 9.84081 9.49876 9.76303 9.46545C9.68526 9.43215 9.6148 9.38385 9.55569 9.32332C9.49658 9.26278 9.44997 9.1912 9.41853 9.11265C9.38709 9.0341 9.37143 8.95013 9.37244 8.86553V8.78117L9.82493 5.6061L7.90761 8.6738L6.80324 10.5758Z"
    fill="white"
  />
</svg>
`
})
export class BoltComponent {

}
